import { ActiveInactive, ProfileAddress, UserDefaultsResponse } from '@tecex-api/data';
import { AddressType } from '../../../enums/address-type.enum';
import { AddressBook } from '../../../interfaces/address/address-book.intefrace';
import { AddressCardAddressVM } from '../../../interfaces/address/address.vm';

export const mapAddressBook = (userDefaults: UserDefaultsResponse): AddressBook => ({
  pickupAddresses: userDefaults.PickupAddress.filter((address) => address.AddressStatus === ActiveInactive.ACTIVE).map((address) =>
    mapProfileAddress(AddressType.Pickup, address)
  ),
  deliveryAddresses: userDefaults.FinalDestinationsAddress.filter((address) => address.AddressStatus === ActiveInactive.ACTIVE).map(
    (address) => mapProfileAddress(AddressType.Delivery, address)
  ),
});

const mapProfileAddress = (addressType: AddressType, address: ProfileAddress): AddressCardAddressVM => ({
  id: address.Id,
  tag: address.PickupaddressName,
  companyName: address.CompanyName,
  contactPerson: address.ContactFullName,
  email: address.ContactEmail,
  phone: address.ContactPhoneNumber,
  additionalPhone: address.AdditionalContactNumber,
  country: address.Country,
  state: address.Province,
  city: address.City,
  streetAddress: address.Address,
  streetAddressTwo: address.Address2,
  streetAddressThree: address.Address3,
  zip: address.PostalCode,
  comment: address.Comments,
  isDefault: addressType === AddressType.Pickup ? address.Default : false,
  isActive: address.AddressStatus === ActiveInactive.ACTIVE,
  pickupPreference: address.PickupPreference,
});
